/**
 * Public setup-status check — uses fetch (not axios) so interceptors,
 * retry storms, and hung requests cannot block the onboarding wizard.
 */
export async function getSetupStatus({ timeoutMs = 6000 } = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const token = localStorage.getItem("token");
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;

    const res = await fetch("/api/public/setup-status", {
      signal: controller.signal,
      headers,
      credentials: "same-origin",
    });

    if (!res.ok) {
      throw new Error(`setup-status HTTP ${res.status}`);
    }

    return await res.json();
  } finally {
    clearTimeout(timer);
  }
}
